import { render } from "./PageDersNotlari.vue?vue&type=template&id=6e867ed9&scoped=true"
import script from "./PageDersNotlari.vue?vue&type=script&lang=js"
export * from "./PageDersNotlari.vue?vue&type=script&lang=js"

import "./PageDersNotlari.vue?vue&type=style&index=0&id=6e867ed9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e867ed9"

export default script